module.exports = __webpack_public_path__ + "img/helpSteps3-1-1.48416ca4.png";